"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pascalToSnake = exports.pascalToCapitalized = exports.pascalToCamel = exports.pascalToKebab = exports.camelToPascal = exports.kebabToCapitalized = exports.camelToCapitalized = exports.camelToSnake = exports.camelToKebab = exports.kebabToSnake = exports.kebabToPascal = exports.kebabToCamel = exports.snakeToCapitalized = exports.snakeToPascal = exports.snakeToKebab = exports.snakeToCamel = exports.capitalize = void 0;
const camelToCapitalized_1 = require("./conversions/camelToCapitalized");
const camelToKebab_1 = require("./conversions/camelToKebab");
const camelToPascal_1 = require("./conversions/camelToPascal");
const camelToSnake_1 = require("./conversions/camelToSnake");
const capitalize_1 = require("./conversions/capitalize");
const kebabToCamel_1 = require("./conversions/kebabToCamel");
const kebabToCapitalized_1 = require("./conversions/kebabToCapitalized");
const kebabToPascal_1 = require("./conversions/kebabToPascal");
const kebabToSnake_1 = require("./conversions/kebabToSnake");
const pascalToCamel_1 = require("./conversions/pascalToCamel");
const pascalToCapitalized_1 = require("./conversions/pascalToCapitalized");
const pascalToKebab_1 = require("./conversions/pascalToKebab");
const pascalToSnake_1 = require("./conversions/pascalToSnake");
const snakeToCamel_1 = require("./conversions/snakeToCamel");
const snakeToCapitalized_1 = require("./conversions/snakeToCapitalized");
const snakeToKebab_1 = require("./conversions/snakeToKebab");
const snakeToPascal_1 = require("./conversions/snakeToPascal");
const convert_1 = __importDefault(require("./convert"));
const capitalize = (input) => (0, convert_1.default)(input, capitalize_1.capitalizeConverter);
exports.capitalize = capitalize;
const snakeToCamel = (input) => (0, convert_1.default)(input, snakeToCamel_1.snakeToCamelConverter);
exports.snakeToCamel = snakeToCamel;
const snakeToKebab = (input) => (0, convert_1.default)(input, snakeToKebab_1.snakeToKebabConverter);
exports.snakeToKebab = snakeToKebab;
const snakeToPascal = (input) => (0, convert_1.default)(input, snakeToPascal_1.snakeToPascalConverter);
exports.snakeToPascal = snakeToPascal;
const snakeToCapitalized = (input) => (0, convert_1.default)(input, snakeToCapitalized_1.snakeToCapitalizedConverter);
exports.snakeToCapitalized = snakeToCapitalized;
const kebabToCamel = (input) => (0, convert_1.default)(input, kebabToCamel_1.kebabToCamelConverter);
exports.kebabToCamel = kebabToCamel;
const kebabToPascal = (input) => (0, convert_1.default)(input, kebabToPascal_1.kebabToPascalConverter);
exports.kebabToPascal = kebabToPascal;
const kebabToSnake = (input) => (0, convert_1.default)(input, kebabToSnake_1.kebabToSnakeConverter);
exports.kebabToSnake = kebabToSnake;
const camelToKebab = (input) => (0, convert_1.default)(input, camelToKebab_1.camelToKebabConverter);
exports.camelToKebab = camelToKebab;
const camelToSnake = (input) => (0, convert_1.default)(input, camelToSnake_1.camelToSnakeConverter);
exports.camelToSnake = camelToSnake;
const camelToCapitalized = (input) => (0, convert_1.default)(input, camelToCapitalized_1.camelToCapitalizedConverter);
exports.camelToCapitalized = camelToCapitalized;
const kebabToCapitalized = (input) => (0, convert_1.default)(input, kebabToCapitalized_1.kebabToCapitalizedConverter);
exports.kebabToCapitalized = kebabToCapitalized;
const camelToPascal = (input) => (0, convert_1.default)(input, camelToPascal_1.camelToPascalConverter);
exports.camelToPascal = camelToPascal;
const pascalToKebab = (input) => (0, convert_1.default)(input, pascalToKebab_1.pascalToKebabConverter);
exports.pascalToKebab = pascalToKebab;
const pascalToCamel = (input) => (0, convert_1.default)(input, pascalToCamel_1.pascalToCamelConverter);
exports.pascalToCamel = pascalToCamel;
const pascalToCapitalized = (input) => (0, convert_1.default)(input, pascalToCapitalized_1.pascalToCapitalizedConverter);
exports.pascalToCapitalized = pascalToCapitalized;
const pascalToSnake = (input) => (0, convert_1.default)(input, pascalToSnake_1.pascalToSnakeConverter);
exports.pascalToSnake = pascalToSnake;
//# sourceMappingURL=index.js.map